// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"daffcb34","115":"2de5a7f7"}[chunkId] + ".chunk.js";
};